import antdData from 'antd/locale/fr_FR'
import localeData from 'react-intl/locale-data/fr'

import error from './error'
import form from './form'
import global from './global'
import license from './license'
import notification from './notification'
import settings from './settings'
import sustainability from './sustainability'
import widget from './widget'

export default {
  locale: 'fr-FR',
  antdData,
  localeData,
  messages: {
    ...global,
    ...form,
    ...settings,
    ...widget,
    ...sustainability,
    ...error,
    ...notification,
    ...license,
  },
}
